/* Cart drawer logic — extracted from sections/cart-drawer.liquid (was ~39KB
   inline in every HTML response; now cached). Loaded defer: the code already
   gates on DOMContentLoaded/readyState, and window.cart consumers (live chat,
   cart bar) call it at interaction time, long after deferred scripts run. */
// =============================================
// CART NOTES
// =============================================
function initCartNotes() {
  const noteInput = document.querySelector('.js-cart-note');
  if (!noteInput) return;
  
  let debounceTimer;
  
  noteInput.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: this.value })
      });
    }, 500);
  });
}
 (function() {
  const REVIEWS_API = 'https://script.google.com/macros/s/AKfycbxU_lJJ6jhDuOSL5VmAwW1bCKT7cV-KHMH1mQ3eWKV3f8BY3aFZYry9o22q0dJHACTf/exec';
  let cachedReviews = null;
  let isAddingSample = false;

  // =============================================
  // EVENT DELEGATION
  // =============================================
  function initEventDelegation() {
    const drawer = document.querySelector('.cart-drawer');
    if (!drawer) return;
    
    drawer.removeEventListener('click', handleDrawerClick);
    drawer.addEventListener('click', handleDrawerClick);
  }

  async function handleDrawerClick(e) {
    const target = e.target;
    
    // 1. THE CHECKOUT FIX (Programmatic Navigation) - OPTIMIZED
    if (target.closest('.js-checkout-btn')) {
      e.preventDefault();
      const btn = target.closest('.js-checkout-btn');

      // Visual feedback + unlock in same frame
      btn.classList.add('is-loading');
      document.body.classList.remove('overflow-hidden');

      // Immediate redirect using requestAnimationFrame for smoothest possible transition
      requestAnimationFrame(() => {
        window.location.href = btn.href;
      });
      return;
    }

    // 2. CLOSE CART LOGIC
    if (target.closest('.js-cart-close') || target.classList.contains('cart-drawer__overlay')) {
      closeCart();
      return;
    }
    
    // 3. QUICK ADD (Recommendations)
    if (target.closest('.js-quick-add')) {
      e.preventDefault();
      e.stopPropagation();
      const btn = target.closest('.js-quick-add');
      await handleQuickAdd(btn);
      return;
    }
    
    // 4. QUANTITY ADJUSTMENTS
    if (target.closest('.js-quantity-minus')) {
      const btn = target.closest('.js-quantity-minus');
      await updateQuantity(btn.dataset.key, -1);
      return;
    }
    
    if (target.closest('.js-quantity-plus')) {
      const btn = target.closest('.js-quantity-plus');
      await updateQuantity(btn.dataset.key, 1);
      return;
    }
    
    // 5. REMOVE ITEM
    if (target.closest('.js-remove-item')) {
      const btn = target.closest('.js-remove-item');
      await removeItem(btn.dataset.key);
      return;
    }
    
    // 6. PROMO TOGGLE
    if (target.closest('.js-promo-toggle')) {
      togglePromo();
      return;
    }

    // 7. PROMO APPLY
    if (target.closest('.js-promo-apply')) {
      applyPromo();
      return;
    }
  }

  // =============================================
  // QUICK ADD
  // =============================================
  async function handleQuickAdd(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      });

      if (response.ok) {
        btn.textContent = '✓';
        await refreshCart();
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1000);
      } else {
        btn.textContent = originalText;
        btn.disabled = false;
      }
    } catch (error) {
      console.error('Quick add error:', error);
      btn.textContent = originalText;
      btn.disabled = false;
    }
  }

  // =============================================
  // CART OPEN/CLOSE
  // =============================================
  async function openCart() {
  const drawer = document.querySelector('.js-cart-drawer');
  if (drawer) {
    drawer.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    pushCartState(); // back gesture / back button now closes the drawer

    // Hide all header elements when cart opens
    const headerSelectors = [
      '.site-header',
      '.section-header',
      'header',
      '.header',
      '.shopify-section-header',
      '[role="banner"]',
      '#shopify-section-header',
      '.header-section'
    ];

    headerSelectors.forEach(selector => {
      const element = document.querySelector(selector);
      if (element && !element.classList.contains('cart-drawer')) {
        element.style.display = 'none';
      }
    });

    // (paintCartNow runs from the is-open observer below, which also covers
    // the add-to-cart path where global.js opens the drawer without calling
    // this function.)

    // Refresh cart to ensure we have the latest items
    await refreshCart();

    // Populate reviews for items in cart (await if not yet loaded)
    if (!cachedReviews) await prefetchReviews();
    if (cachedReviews) {
      const cards = document.querySelectorAll('.cart-drawer__review-card[data-handle]');
      populateReviewCards(cards);
    }

    // Populate empty cart state
    populateEmptyCart();
      }
    }


  function closeCart() {
    const drawer = document.querySelector('.js-cart-drawer');
    if (drawer) {
      drawer.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
      popCartState(); // consume the history entry pushed on open (no-op if none)

      // Show all header elements when cart closes
      const headerSelectors = [
        '.site-header',
        '.section-header',
        'header',
        '.header',
        '.shopify-section-header',
        '[role="banner"]',
        '#shopify-section-header',
        '.header-section'
      ];

      headerSelectors.forEach(selector => {
        const element = document.querySelector(selector);
        if (element && !element.classList.contains('cart-drawer')) {
          element.style.display = '';
        }
      });
    }
  }
  // =============================================
  // SWIPE TO CLOSE + DEVICE BACK GESTURE
  //
  // Both are wired defensively because TWO scripts drive this drawer:
  // cart-drawer.js (this file) and the CartDrawer class in global.js. On
  // add-to-cart, global.js opens the drawer and its refresh() replaces
  // .js-cart-drawer's innerHTML — which DESTROYS the panel element. So:
  //   * touch listeners are delegated from document (never bound to the panel
  //     element itself, which gets recreated), and
  //   * history state is driven by a MutationObserver on the is-open class,
  //     so it fires no matter which script opened or closed the drawer.
  // =============================================
  (function() {
    var startX = 0, startY = 0, startT = 0;
    var currentX = 0;
    var panel = null;        // resolved fresh on each touchstart
    var isSwiping = false;
    var decided = false;

    // Close if dragged past ~25% of the panel, OR flicked quickly. The original
    // rule was a flat 200px — more than half a phone screen, so most swipes
    // snapped back and it felt like the gesture did nothing.
    function shouldClose(dist, ms) {
      var w = (panel && panel.offsetWidth) || window.innerWidth;
      return dist > Math.min(110, w * 0.25) ||
             (dist > 45 && (dist / Math.max(ms, 1)) > 0.5);
    }

    function resetPanel(animate) {
      if (!panel) return;
      panel.style.transition = animate ? 'transform 0.25s ease' : '';
      panel.style.transform = '';
      if (animate) {
        var p = panel;
        setTimeout(function() { p.style.transition = ''; }, 250);
      }
    }

    document.addEventListener('touchstart', function(e) {
      panel = null;
      isSwiping = false;
      decided = false;
      if (e.touches.length !== 1) return;

      var drawer = document.querySelector('.js-cart-drawer');
      if (!drawer || !drawer.classList.contains('is-open')) return;

      // Only start a swipe if the touch began inside the panel
      var t = e.target;
      var inPanel = t && t.closest ? t.closest('.cart-drawer__panel') : null;
      if (!inPanel) return;

      panel = inPanel;
      startX = currentX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startT = Date.now();
      panel.style.transition = 'none';
    }, { passive: true });

    document.addEventListener('touchmove', function(e) {
      if (!panel || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;

      // First real movement decides horizontal vs vertical, so scrolling the
      // cart list vertically never drags the panel sideways.
      if (!decided) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        decided = true;
        isSwiping = Math.abs(dx) > Math.abs(dy);
        if (!isSwiping) { panel.style.transition = ''; panel = null; return; }
      }
      if (!isSwiping) return;

      currentX = e.touches[0].clientX;
      if (dx > 0) panel.style.transform = 'translateX(' + dx + 'px)';
    }, { passive: true });

    document.addEventListener('touchend', function() {
      if (!panel) return;
      if (!isSwiping) { resetPanel(false); panel = null; return; }
      isSwiping = false;

      var dist = currentX - startX;
      var ms = Date.now() - startT;

      if (dist > 0 && shouldClose(dist, ms)) {
        var p = panel;
        p.style.transition = 'transform 0.25s ease';
        p.style.transform = 'translateX(100%)';
        setTimeout(function() {
          closeCart();
          p.style.transition = '';
          p.style.transform = '';
        }, 250);
      } else {
        resetPanel(true);
      }
      panel = null;
    });

    document.addEventListener('touchcancel', function() {
      resetPanel(false);
      isSwiping = false;
      panel = null;
    });
  })();

  // ---- Device back gesture / back button closes the drawer ----
  var cartStatePushed = false;

  function pushCartState() {
    if (cartStatePushed) return;
    try {
      history.pushState({ mburCartOpen: true }, '');
      cartStatePushed = true;
    } catch (e) {}
  }

  function popCartState() {
    if (!cartStatePushed) return;
    cartStatePushed = false; // cleared first so the popstate handler no-ops
    try { history.back(); } catch (e) {}
  }

  window.addEventListener('popstate', function() {
    // Clear unconditionally: this pop consumed our entry whether or not the
    // drawer is still open.
    cartStatePushed = false;
    var drawer = document.querySelector('.js-cart-drawer');
    if (drawer && drawer.classList.contains('is-open')) closeCart();
  });

  /* Fill the review cards regardless of HOW the drawer was opened.
     populateReviewCards() only ran inside openCart(), but global.js opens the
     drawer directly on add-to-cart and never calls it — so in the most common
     flow the cards were never filled and the loading skeleton sat there
     forever (confirmed by the shop owner: "it doesnt turn into a review").
     Safe to call repeatedly: it re-reads the cards and the cache. */
  /* Build the cart's review carousel from /cart.js instead of relying on the
     server-rendered cards.

     Why: the review section is rendered by Liquid at PAGE LOAD. Open a page
     with an empty cart and the drawer contains the empty-cart slider and NO
     per-item cards at all. Adding a candle then makes paintCartNow() hide the
     empty-cart slider — leaving nothing to populate, so the drawer showed no
     reviews and looked "as if it's the first candle being added". Every
     previous fix assumed those cards existed.

     Driving off /cart.js makes it independent of which script re-rendered the
     drawer, and gives one card per distinct candle in the cart — the carousel
     the slider CSS was already set up for. */
  async function renderCartReviews() {
    const panel = document.querySelector('.cart-drawer__panel');
    if (!panel) return;

    let cart;
    try { cart = await (await fetch('/cart.js')).json(); } catch (e) { return; }
    if (!cart || !cart.item_count) return;  // empty cart is populateEmptyCart()'s job

    const emptySec = panel.querySelector('.cart-drawer__reviews--empty');
    if (emptySec) emptySec.style.display = 'none';

    if (!cachedReviews) await prefetchReviews();
    if (!cachedReviews) return;

    // distinct product handles in the cart, sample excluded
    const seen = {};
    const inCart = [];
    cart.items.forEach(function (i) {
      let h = i.handle || ((i.url || '').split('/products/')[1] || '').split('?')[0];
      if (!h || h === 'pure-beeswax-candle-sample' || seen[h]) return;
      seen[h] = true;
      inCart.push({ handle: h, title: i.product_title || i.title || '' });
    });

    const withReviews = inCart.filter(function (p) {
      return (cachedReviews[p.handle] || []).some(function (r) { return r.rating === 5; });
    });

    let section = panel.querySelector('.cart-drawer__reviews:not(.cart-drawer__reviews--empty)');
    if (!withReviews.length) {
      if (section) section.style.display = 'none';
      return;
    }

    // Section may not exist at all (page loaded with an empty cart) — create it
    // right after the items, matching the order the Liquid renders.
    if (!section) {
      const itemsWrap = panel.querySelector('.cart-drawer__items');
      const host = itemsWrap || panel.querySelector('.cart-drawer__scrollable');
      if (!host) return;
      const shell = '<div class="cart-drawer__reviews">' +
        '<p class="cart-drawer__section-label">What Customers Say</p>' +
        '<div class="cart-drawer__reviews-slider" id="reviews-slider"></div></div>';
      if (itemsWrap) itemsWrap.insertAdjacentHTML('afterend', shell);
      else host.insertAdjacentHTML('beforeend', shell);
      section = panel.querySelector('.cart-drawer__reviews:not(.cart-drawer__reviews--empty)');
      if (!section) return;
    }

    const slider = section.querySelector('.cart-drawer__reviews-slider');
    if (!slider) return;

    // Rebuild only when the set of candles changed, otherwise the MutationObserver
    // that calls this would see fresh empty cards and loop forever.
    const key = withReviews.map(function (p) { return p.handle; }).join('|');
    if (slider.dataset.mburReviewKey !== key) {
      slider.dataset.mburReviewKey = key;
      slider.innerHTML = withReviews.map(function (p) {
        return '<div class="cart-drawer__review-card" data-handle="' + p.handle + '">' +
          '<div class="review-card__header">' +
            '<span class="review-card__product"></span>' +
            '<span class="review-card__rating"></span>' +
          '</div>' +
          '<p class="review-card__text"></p>' +
          '<span class="review-card__author"></span>' +
        '</div>';
      }).join('');
      withReviews.forEach(function (p, i) {
        const el = slider.children[i] && slider.children[i].querySelector('.review-card__product');
        if (el) el.textContent = cleanProductName(p.title);   // textContent: no markup injection
      });
    }

    section.style.display = '';
    // fills text/stars/author synchronously, so the observer sees populated cards
    populateReviewCards(slider.querySelectorAll('.cart-drawer__review-card[data-handle]'));
    ensureReviewArrows(slider);
  }

  /* Circular prev/next controls over the review carousel. The slider was
     swipeable but gave no signal that more reviews existed beside it, so with
     several candles in the cart the extra reviews were effectively invisible.
     Only rendered when there is more than one card. */
  function ensureReviewArrows(slider) {
    if (!slider) return;
    var cards = slider.querySelectorAll('.cart-drawer__review-card');

    // The arrows need a positioned box around JUST the slider, so wrap it once.
    var viewport = slider.parentElement;
    if (!viewport || !viewport.classList.contains('cart-drawer__reviews-viewport')) {
      viewport = document.createElement('div');
      viewport.className = 'cart-drawer__reviews-viewport';
      slider.parentNode.insertBefore(viewport, slider);
      viewport.appendChild(slider);
    }

    var nav = viewport.querySelector('.cart-drawer__reviews-nav');
    if (cards.length < 2) {           // nothing to page through
      if (nav) nav.remove();
      return;
    }
    if (nav) { updateArrowState(); return; }

    var arrow = function (dir, label, path) {
      return '<button type="button" class="cart-drawer__reviews-arrow cart-drawer__reviews-arrow--' + dir + '" aria-label="' + label + '">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<path d="' + path + '" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    };
    viewport.insertAdjacentHTML('beforeend',
      '<div class="cart-drawer__reviews-nav">' +
        arrow('prev', 'Previous review', 'M15 18l-6-6 6-6') +
        arrow('next', 'Next review', 'M9 18l6-6-6-6') +
      '</div>');

    var prevBtn = viewport.querySelector('.cart-drawer__reviews-arrow--prev');
    var nextBtn = viewport.querySelector('.cart-drawer__reviews-arrow--next');

    function step(dir) {
      var card = slider.querySelector('.cart-drawer__review-card');
      var w = card ? card.offsetWidth + 12 : slider.clientWidth;   // 12px = slider gap
      slider.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    prevBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); step(-1); });
    nextBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); step(1); });

    function updateArrowState() {
      var p = viewport.querySelector('.cart-drawer__reviews-arrow--prev');
      var n = viewport.querySelector('.cart-drawer__reviews-arrow--next');
      if (!p || !n) return;
      var max = slider.scrollWidth - slider.clientWidth;
      p.disabled = slider.scrollLeft <= 2;
      n.disabled = slider.scrollLeft >= max - 2;
    }
    slider.addEventListener('scroll', updateArrowState, { passive: true });
    updateArrowState();
  }

  // Kept as the entry point used by the drawer hooks.
  async function ensureReviewsPopulated() {
    try {
      await renderCartReviews();
    } catch (e) {
      const skeleton = document.querySelector('.cart-drawer__review-card[data-review-skeleton]');
      if (skeleton) skeleton.style.display = 'none';
    }
  }

  /* Warm the review cache once, after load and on idle. prefetchReviews() was
     taken out of init() because it fired an Apps Script call on every page
     view; this keeps it off the critical path but has the data ready BEFORE
     the drawer is opened. That Apps Script call measured 2.6-8.6s, which is
     how long the skeleton would otherwise be on screen. */
  function warmReviewCache() {
    if (cachedReviews) return;
    prefetchReviews().catch(function () {});
  }
  (function () {
    function onIdle(fn) {
      if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 4000 });
      else setTimeout(fn, 1500);
    }
    if (document.readyState === 'complete') onIdle(warmReviewCache);
    else window.addEventListener('load', function () { onIdle(warmReviewCache); });
  })();

  /* The drawer's markup is replaced wholesale on every cart change — by this
     file's refreshCart() AND by global.js's own refresh(), which never
     populates reviews. Adding a second candle to a cart that already had one
     therefore swapped in a brand-new skeleton that nothing ever filled, and it
     froze there. Watching the open transition cannot catch this: the drawer
     was already open the whole time.

     So watch for review cards APPEARING instead. Self-limiting: it only acts
     when a visible card still has empty text, or a skeleton is still showing —
     both false once populateReviewCards() has run, so filling them cannot
     retrigger this. */
  (function () {
    var drawer = document.querySelector('.js-cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    var pending = null;

    function needsPopulating() {
      var cards = drawer.querySelectorAll('.cart-drawer__review-card[data-handle]');
      for (var i = 0; i < cards.length; i++) {
        var t = cards[i].querySelector('.review-card__text');
        if (cards[i].style.display !== 'none' && t && !t.textContent.trim()) return true;
      }
      var skel = drawer.querySelector('.cart-drawer__review-card[data-review-skeleton]');
      return !!(skel && skel.style.display !== 'none');
    }

    new MutationObserver(function () {
      if (pending || !needsPopulating()) return;
      pending = setTimeout(function () {
        pending = null;
        ensureReviewsPopulated();
      }, 120);
    }).observe(drawer, { childList: true, subtree: true });
  })();

  // Watch the is-open class rather than hooking openCart()/closeCart(): the
  // drawer is also opened by global.js on add-to-cart, which never calls this
  // file's openCart(), so hooking it alone left no history entry and the back
  // gesture navigated off the page instead of closing the cart.
  (function() {
    var drawer = document.querySelector('.js-cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    var wasOpen = drawer.classList.contains('is-open');
    if (wasOpen) pushCartState();

    new MutationObserver(function() {
      var isOpen = drawer.classList.contains('is-open');
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;
      if (isOpen) {
        pushCartState();
        // Paint products from /cart.js the moment the drawer opens, whichever
        // script opened it. This observer is the only hook that catches BOTH
        // paths — global.js opens the drawer on add-to-cart without ever
        // calling this file's openCart().
        paintCartNow();
        ensureReviewsPopulated();
      } else {
        popCartState();
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  })();

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  // =============================================
  // QUANTITY & REMOVE
  // =============================================
  async function updateQuantity(key, change) {
    const input = document.querySelector(`.cart-item__qty-input[data-key="${key}"]`);
    if (!input) return;

    const newQty = Math.max(1, parseInt(input.value) + change);

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      });

      if (response.ok) {
        await refreshCart();
      }
    } catch (error) {
      console.error('Update quantity error:', error);
    }
  }

  async function removeItem(key) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });

      if (response.ok) {
        await refreshCart();
      }
    } catch (error) {
      console.error('Remove item error:', error);
    }
  }

  // =============================================
  // SAMPLE SELECTOR
  // =============================================
  function initSampleSelector() {
    document.querySelectorAll('.js-sample-dropdown').forEach(dd => {
      if (dd.dataset.initialized) return;
      dd.dataset.initialized = 'true';
      
      dd.addEventListener('change', async function() {
        if (!this.value || isAddingSample) return;
        
        isAddingSample = true;
        this.closest('.cart-drawer__sample-select-wrap')?.classList.add('is-loading');
        this.disabled = true;
        
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: parseInt(this.value),
              quantity: 1,
              properties: { '_free_sample': 'true' }
            })
          });
          refreshCart();
        } catch (error) {
          this.disabled = false;
          this.closest('.cart-drawer__sample-select-wrap')?.classList.remove('is-loading');
        } finally {
          isAddingSample = false;
        }
      });
    });
  }

  // =============================================
  // PROMO CODE
  // =============================================
  function togglePromo() {
    const toggle = document.querySelector('.js-promo-toggle');
    const form = document.getElementById('promo-form');
    
    if (toggle && form) {
      const isOpen = form.classList.toggle('is-open');
      toggle.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen);
    }
  }

  // =============================================
  // PROMO CODE APPLY
  // =============================================
  // Every discount title currently on the cart (cart-level + line-level).
  function discountTitles(cart) {
    var out = [];
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      var t = d.discount_application ? d.discount_application.title : d.title;
      if (t) out.push(String(t));
    });
    (cart.items || []).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (a) {
        if (a.discount_application && a.discount_application.title) out.push(String(a.discount_application.title));
      });
    });
    return out;
  }

  // Repaint Subtotal + the Discount line from a cart object.
  function renderCartTotals(cart) {
    var sub = document.querySelector('.js-cart-subtotal');
    if (sub) sub.textContent = moneyFromCents(cart.total_price);

    var line = document.querySelector('.js-discount-line');
    if (!line) return;
    var saved = cart.total_discount || 0;
    if (saved > 0) {
      var label = document.querySelector('.js-discount-code-label');
      var amount = document.querySelector('.js-discount-amount');
      var titles = discountTitles(cart);
      if (label) label.textContent = titles.length ? titles[0] : '';
      if (amount) amount.textContent = '-' + moneyFromCents(saved);
      line.style.display = '';
    } else {
      line.style.display = 'none';
    }
  }

  /* Apply a discount code WITHOUT leaving the page.
     Shopify's AJAX Cart API has no method for discount codes — the only
     storefront mechanism is the /discount/{code} route, which applies the code
     to the session. Adding ?redirect=/cart.js makes it return the updated cart
     as JSON in a single request instead of a full HTML page.

     There is no error status to read: an invalid code still answers 200 and
     silently changes nothing (verified against the live store). So success is
     detected by diffing the cart before and after — either the saving grew, or
     the entered code now appears among the applied discount titles. An invalid
     code also does NOT clear an already-applied one, so a typo cannot cost the
     customer a discount they already had. */
  async function applyPromo() {
    const input = document.querySelector('.js-promo-input') ||
                  document.querySelector('.cart-drawer__promo-input');
    const btn = document.querySelector('.js-promo-apply');
    const msg = document.querySelector('.js-promo-msg');
    if (!input || !btn) return;

    const code = input.value.trim();
    if (!code) {
      input.focus();
      return;
    }

    const originalLabel = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';
    if (msg) {
      msg.textContent = '';
      msg.className = 'cart-drawer__promo-msg js-promo-msg';
    }

    function say(text, kind) {
      if (!msg) return;
      msg.textContent = text;
      msg.className = 'cart-drawer__promo-msg js-promo-msg is-' + kind;
    }

    try {
      const before = await (await fetch('/cart.js')).json();
      const after = await (await fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
        headers: { 'Accept': 'application/json' }
      })).json();

      const gained = (after.total_discount || 0) - (before.total_discount || 0);
      const named = discountTitles(after).some(function (t) {
        return t.toLowerCase() === code.toLowerCase();
      });

      renderCartTotals(after);

      if (gained > 0) {
        say('Code applied — you saved ' + moneyFromCents(after.total_discount) + '.', 'success');
        input.value = '';
      } else if (named) {
        say('That code is already applied.', 'success');
        input.value = '';
      } else {
        say("That code isn't valid for this cart.", 'error');
      }

      if (typeof MburTracker !== 'undefined' && MburTracker.trackCustomEvent) {
        MburTracker.trackCustomEvent('discount_code_applied', {
          discount_code: code,
          applied: (gained > 0 || named) ? 'yes' : 'no',
          discount_amount: (after.total_discount || 0) / 100,
          cart_value: (after.total_price || 0) / 100
        });
      }
    } catch (e) {
      say("Couldn't apply that code right now. It will still work at checkout.", 'error');
    }

    btn.disabled = false;
    btn.textContent = originalLabel;
  }

  // Enter in the code field applies it (the field is always open now, so it is
  // the first thing a keyboard user lands on in the footer).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('cart-drawer__promo-input')) return;
    e.preventDefault();
    applyPromo();
  });

  // =============================================
  // APPLE PAY - Direct Payment Request
  // =============================================
  function initApplePay() {
    const applePayBtn = document.querySelector('.js-apple-pay-btn');
    if (!applePayBtn) return;
    
    // Check if Apple Pay is available
    if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
      applePayBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        
        try {
          // Fetch cart data
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          
          // Create Apple Pay session
          const paymentRequest = {
            countryCode: 'US',
            currencyCode: 'USD',
            supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
            merchantCapabilities: ['supports3DS'],
            total: {
              label: 'MBur Candle Co.',
              amount: (cart.total_price / 100).toFixed(2)
            },
            requiredShippingContactFields: ['postalAddress', 'email', 'phone', 'name'],
            requiredBillingContactFields: ['postalAddress']
          };
          
          const session = new ApplePaySession(3, paymentRequest);
          
          session.onvalidatemerchant = async (event) => {
            // You'll need a server endpoint to validate with Apple
            // This typically calls Shopify's payment session API
            try {
              const response = await fetch('/wallets/checkouts/apple-pay/validate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ validationURL: event.validationURL })
              });
              const merchantSession = await response.json();
              session.completeMerchantValidation(merchantSession);
            } catch (err) {
              session.abort();
            }
          };
          
          session.onpaymentauthorized = async (event) => {
            // Process the payment through Shopify
            try {
              const response = await fetch('/wallets/checkouts/apple-pay/complete', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ payment: event.payment })
              });
              
              if (response.ok) {
                session.completePayment(ApplePaySession.STATUS_SUCCESS);
                window.location.href = '/checkout/thank_you';
              } else {
                session.completePayment(ApplePaySession.STATUS_FAILURE);
              }
            } catch (err) {
              session.completePayment(ApplePaySession.STATUS_FAILURE);
            }
          };
          
          session.begin();
        } catch (error) {
          console.error('Apple Pay error:', error);
          // Fallback to regular checkout
          window.location.href = '/checkout';
        }
      });
    } else {
      // Hide Apple Pay if not supported
      applePayBtn.style.display = 'none';
    }
  }

  // =============================================
  // INSTANT CART PAINT
  // =============================================
  // The drawer's HTML is rendered by Liquid at PAGE LOAD, so on a page opened
  // with an empty cart it still contains the empty state. openCart() then had
  // to wait for refreshCart() — a full `/cart?section_id=cart-drawer` render —
  // before any product appeared. Measured live: drawer visible at 365ms, first
  // product row at 1401ms, i.e. ~1s staring at "your cart is empty" after an
  // add. `/cart.js` is plain JSON and answers in a fraction of that, so paint
  // the rows from it immediately and let refreshCart() replace them with the
  // authoritative markup a moment later.
  function moneyFromCents(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function cartItemRowHTML(item) {
    var img = item.image || (item.featured_image && item.featured_image.url) || '';
    // Ask the CDN for a 140px-wide copy rather than the full-size original
    var thumb = img ? img.replace(/(\.(?:jpe?g|png|webp|avif|gif))(\?|$)/i, '_140x$1$2') : '';
    var key = String(item.key || '');
    return '' +
      '<div class="cart-item" data-key="' + key + '">' +
        '<a href="' + (item.url || '#') + '" class="cart-item__image">' +
          (thumb ? '<img src="' + thumb + '" alt="" loading="lazy" width="70" height="70">' : '') +
        '</a>' +
        '<div class="cart-item__info">' +
          '<div class="cart-item__header">' +
            '<div class="cart-item__titles">' +
              '<a href="' + (item.url || '#') + '" class="cart-item__title"></a>' +
              (item.variant_title ? '<p class="cart-item__variant"></p>' : '') +
            '</div>' +
            '<span class="cart-item__price">' + moneyFromCents(item.final_line_price) + '</span>' +
          '</div>' +
          '<div class="cart-item__actions">' +
            '<div class="cart-item__quantity">' +
              '<button class="cart-item__qty-btn js-quantity-minus" data-key="' + key + '" aria-label="Decrease quantity">' +
                '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
              '</button>' +
              '<input type="number" class="cart-item__qty-input" value="' + (item.quantity || 1) + '" min="1" data-key="' + key + '" inputmode="numeric" readonly aria-label="Quantity">' +
              '<button class="cart-item__qty-btn js-quantity-plus" data-key="' + key + '" aria-label="Increase quantity">' +
                '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
              '</button>' +
            '</div>' +
            '<button class="cart-item__remove js-remove-item" data-key="' + key + '" aria-label="Remove item">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  // What the shopper just clicked, captured from the page BEFORE the add has
  // committed. Measured live: when the drawer opens, /cart.js still reports 0
  // items — the drawer is opened optimistically while /cart/add.js is still in
  // flight. So there is nothing to fetch yet; the only way to show the product
  // immediately is to read it off the page they clicked.
  var pendingAdd = null;
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest(
      '.js-pp-atc-btn, .js-add-to-cart, .cp-card__atc, .js-card-quick-add, ' +
      '.js-quick-add, .js-sticky-add, button[name="add"]'
    );
    if (!btn) return;
    var scope = btn.closest('.cp-card, .product-card, .pp-buybox, form') || document;
    function pick(sel) { var el = scope.querySelector(sel) || document.querySelector(sel); return el; }
    var titleEl = pick('.pp-buybox__title, .cp-card__title, .product-card__title, .product-title, h1');
    var priceEl = pick('.js-pp-current-price, .pp-buybox__price-current, .cp-card__price--current, .product-card__price--current');
    var imgEl = scope.querySelector('.cp-card__img--primary, .product-card__image, img') ||
                document.querySelector('.pp-gallery__image.is-active, .pp-gallery__image');
    pendingAdd = {
      title: titleEl ? titleEl.textContent.trim() : '',
      price: priceEl ? priceEl.textContent.trim() : '',
      image: imgEl ? (imgEl.currentSrc || imgEl.src || '') : '',
      at: Date.now()
    };
  }, true);

  function provisionalRowHTML(info) {
    return '' +
      '<div class="cart-item cart-item--pending" data-pending-row>' +
        '<span class="cart-item__image">' +
          (info.image ? '<img src="' + info.image + '" alt="" width="70" height="70">' : '') +
        '</span>' +
        '<div class="cart-item__info">' +
          '<div class="cart-item__header">' +
            '<div class="cart-item__titles"><span class="cart-item__title"></span></div>' +
            '<span class="cart-item__price">' + (info.price || '') + '</span>' +
          '</div>' +
          '<div class="cart-item__actions"><span class="cart-item__pending-note">Adding…</span></div>' +
        '</div>' +
      '</div>';
  }

  async function paintCartNow() {
    var panel = document.querySelector('.cart-drawer__panel');
    if (!panel) return;
    try {
      var cart = await (await fetch('/cart.js')).json();

      // Add still in flight: show the clicked product straight away, then poll
      // until the server confirms and repaint with the real rows.
      if ((!cart || !cart.item_count) && pendingAdd && Date.now() - pendingAdd.at < 8000) {
        var sc = panel.querySelector('.cart-drawer__scrollable');
        if (sc && !panel.querySelector('.cart-item')) {
          var wrap = panel.querySelector('.cart-drawer__items');
          if (!wrap) {
            sc.insertAdjacentHTML('afterbegin',
              '<p class="cart-drawer__section-label">Your Order</p><div class="cart-drawer__items"></div>');
            wrap = panel.querySelector('.cart-drawer__items');
            ['.cart-drawer__reviews--empty', '#empty-recs'].forEach(function (sel) {
              var el = panel.querySelector(sel); if (el) el.style.display = 'none';
            });
          }
          if (wrap) {
            wrap.innerHTML = provisionalRowHTML(pendingAdd);
            var t = wrap.querySelector('.cart-item__title');
            if (t) t.textContent = pendingAdd.title;
          }
        }
        for (var tries = 0; tries < 12; tries++) {          // ~3s max
          await new Promise(function (r) { setTimeout(r, 250); });
          try {
            cart = await (await fetch('/cart.js')).json();
            if (cart && cart.item_count) break;
          } catch (e) { /* keep waiting */ }
        }
      }

      if (!cart || !cart.item_count) return; // genuinely empty — leave the empty state alone

      var scrollable = panel.querySelector('.cart-drawer__scrollable');
      if (!scrollable) return;
      var itemsWrap = panel.querySelector('.cart-drawer__items');

      // Page was loaded with an empty cart, so the items area doesn't exist
      // yet. INSERT it rather than replacing the scrollable's contents —
      // clobbering would wipe the reviews / notes / recommendations that the
      // section already rendered, only for refreshCart() to rebuild them.
      if (!itemsWrap) {
        scrollable.insertAdjacentHTML('afterbegin',
          '<p class="cart-drawer__section-label">Your Order</p>' +
          '<div class="cart-drawer__items"></div>');
        itemsWrap = panel.querySelector('.cart-drawer__items');
        // Hide the empty-cart blocks while the real cart paints in.
        ['.cart-drawer__reviews--empty', '#empty-recs'].forEach(function (sel) {
          var el = panel.querySelector(sel);
          if (el) el.style.display = 'none';
        });
      }
      if (!itemsWrap) return;

      // replaces the provisional 'Adding…' row, if one is showing
      itemsWrap.innerHTML = cart.items.map(cartItemRowHTML).join('');
      // Titles set via textContent so product names can't inject markup.
      cart.items.forEach(function (item, i) {
        var row = itemsWrap.children[i];
        if (!row) return;
        var t = row.querySelector('.cart-item__title');
        if (t) t.textContent = item.product_title || item.title || '';
        var v = row.querySelector('.cart-item__variant');
        if (v) v.textContent = item.variant_title || '';
      });

      // The section may not exist yet on a page that loaded with an empty cart.
      ensureReviewsPopulated();
    } catch (e) { /* refreshCart() is still on its way */ }
  }

  // =============================================
  // CART REFRESH
  // =============================================
async function refreshCart() {
  try {
    const timestamp = Date.now();
    const response = await fetch('/cart?section_id=cart-drawer&t=' + timestamp);

    if (!response.ok) {
      console.error('Cart refresh failed: Network response not ok');
      return; // Don't clear cart on error
    }

    const html = await response.text();

    if (!html || html.trim().length === 0) {
      console.error('Cart refresh failed: Empty response');
      return; // Don't clear cart on empty response
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newPanel = doc.querySelector('.cart-drawer__panel');
    const currentPanel = document.querySelector('.cart-drawer__panel');

    if (!newPanel) {
      console.error('Cart refresh failed: Could not find cart panel in response');
      return; // Don't clear cart if we can't find the new panel
    }

    if (currentPanel && newPanel) {
      // Store scroll position
      const scrollable = currentPanel.querySelector('.cart-drawer__scrollable');
      const scrollPos = scrollable ? scrollable.scrollTop : 0;

      // Update content
      currentPanel.innerHTML = newPanel.innerHTML;

      // Restore scroll position
      const newScrollable = currentPanel.querySelector('.cart-drawer__scrollable');
      if (newScrollable && scrollPos > 0) {
        newScrollable.scrollTop = scrollPos;
      }

      // Re-initialize features
      initSampleSelector();
      initApplePay();
      initCartNotes();
      initShippingCalculator();

      // Ensure reviews are loaded, then populate product-specific cards
      if (!cachedReviews) await prefetchReviews();
      if (cachedReviews) {
        const cards = currentPanel.querySelectorAll('.cart-drawer__review-card[data-handle]');
        populateReviewCards(cards);
      }

      // Populate empty cart if cart is now empty
      populateEmptyCart();

      console.log('Cart refreshed successfully');
    }
  } catch (error) {
    console.error('Cart refresh error:', error);
    // Don't clear the cart on error - keep the existing content
  }
}

function formatPrice(priceInCents) {
  // Shopify products.json returns prices already in dollar format
  // e.g., 50.00 = $50.00, 20.00 = $20.00
  const price = Number(priceInCents) || 0;
  const dollars = price.toFixed(2);

  console.log('💰 formatPrice - input:', priceInCents, 'price:', price, 'output:', '$' + dollars);

  return '$' + dollars;
}

async function populateEmptyCart() {
  const reviewsWrap = document.getElementById('empty-reviews-slider');
  const recsWrap = document.getElementById('empty-recs');

  console.log('🛒 Populating empty cart...');
  console.log('Reviews wrapper found:', !!reviewsWrap);
  console.log('Cached reviews:', cachedReviews);

  if (!reviewsWrap && !recsWrap) return;

  // Wait for reviews to load if they haven't been fetched yet
  if (reviewsWrap && !cachedReviews) {
    console.log('⏳ Waiting for reviews to load...');
    await prefetchReviews();
  }

  // Populate random reviews from cache
  if (reviewsWrap && cachedReviews) {
    const allReviews = [];
    Object.keys(cachedReviews).forEach(function(handle) {
      cachedReviews[handle].forEach(function(r) {
        // Only include 5-star reviews
        if (r.rating === 5) {
          allReviews.push(r);
        }
      });
    });

    console.log('📝 Total 5-star reviews available:', allReviews.length);

    // Shuffle and pick 3
    for (let i = allReviews.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [allReviews[i], allReviews[j]] = [allReviews[j], allReviews[i]];
    }
    const picks = allReviews.slice(0, 3);
    console.log('✅ Picked 5-star reviews:', picks);

    picks.forEach(function(review, idx) {
      const card = reviewsWrap.querySelector('[data-empty-review="' + idx + '"]');
      if (!card) {
        console.warn('⚠️ Card not found for index:', idx);
        return;
      }
      const product = card.querySelector('.review-card__product');
      const rating = card.querySelector('.review-card__rating');
      const text = card.querySelector('.review-card__text');
      const author = card.querySelector('.review-card__author');

      // Debug: log the review object
      console.log('📋 Empty cart review fields:', Object.keys(review));
      console.log('📋 Empty cart review data:', review);

      var cleanedProductName = cleanProductName(review.product_title || review.product || '');
      if (product) product.textContent = cleanedProductName;
      if (rating) rating.textContent = '★'.repeat(review.rating || 5);
      if (text) text.textContent = review.review || review.body || review.text || '';

      // Format author name as "FirstName L."
      if (author) {
        var authorName = 'Customer';
        if (review.name) {
          var parts = review.name.trim().split(' ');
          if (parts.length === 1) {
            authorName = parts[0];
          } else if (parts.length > 1) {
            var firstName = parts[0];
            var lastInitial = parts[parts.length - 1].charAt(0).toUpperCase();
            authorName = firstName + ' ' + lastInitial + '.';
          }
        }
        console.log('👤 Empty cart - Author:', authorName);
        author.textContent = '— ' + authorName;
      }

      console.log(`✍️ Populated review ${idx}:`, {
        product: review.product_title,
        text: review.body || review.text
      });
    });

    if (picks.length > 0) {
      reviewsWrap.style.display = '';
      console.log('👁️ Reviews section made visible');
    }
  } else {
    console.warn('⚠️ Cannot populate reviews - reviewsWrap:', !!reviewsWrap, 'cachedReviews:', !!cachedReviews);
  }

  // Fetch random recommendations
  if (recsWrap) {
    try {
      const res = await fetch('/products.json?limit=20');
      const data = await res.json();
      const products = data.products || [];

      // Shuffle
      for (let i = products.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [products[i], products[j]] = [products[j], products[i]];
      }

      const slider = document.getElementById('empty-recs-slider');
      if (!slider) return;
      slider.innerHTML = '';

      const picks = products.filter(function(p) {
        return p.handle !== 'pure-beeswax-candle-sample' && p.variants && p.variants.length > 0;
      }).slice(0, 3);

      picks.forEach(function(product) {
        // Pick the highest-priced available variant
        const availableVariants = product.variants.filter(function(v) { return v.available; });
        const variant = availableVariants.length > 0
          ? availableVariants.reduce(function(best, v) { return v.price > best.price ? v : best; })
          : product.variants[0];
        if (!variant) return;

        // Use variant image if available, otherwise use product's first image
        const img = (variant.featured_image && variant.featured_image.src)
          ? variant.featured_image.src.replace(/\.([a-z]+)$/, '_140x.$1')
          : (product.images && product.images.length > 0
            ? product.images[0].src.replace(/\.([a-z]+)$/, '_140x.$1')
            : '');

        // Shopify products.json returns prices in cents (e.g., 5000 = $50.00)
        const formattedPrice = formatPrice(variant.price);

        console.log('💰 Product:', product.title, 'Raw price:', variant.price, 'Formatted:', formattedPrice);

        slider.innerHTML += '<div class="cart-drawer__rec-item">'
          + '<div class="cart-drawer__rec-image-wrap">'
          + '<div class="cart-drawer__rec-image">'
          + (img ? '<img src="' + img + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy" width="45" height="45">' : '')
          + '<div class="cart-drawer__rec-info-bar">'
          + '<span class="rec-info-bar__variant">' + variant.title + '</span>'
          + '<span class="rec-info-bar__price">' + formattedPrice + '</span>'
          + '</div>'
          + '</div>'
          + '<button class="cart-drawer__rec-add js-quick-add" data-variant-id="' + variant.id + '" aria-label="Add ' + product.title.replace(/"/g, '&quot;') + ' to cart">+</button>'
          + '</div>'
          + '<span class="cart-drawer__rec-title">' + product.title + '</span>'
          + '</div>';
      });

      if (picks.length > 0) recsWrap.style.display = '';
    } catch (err) {
      console.error('Empty cart recs failed:', err);
    }
  }
}


  // =============================================
  // REVIEWS
  // =============================================

  // Clean up product names for display in reviews
  function cleanProductName(productName) {
    if (!productName) return '';

    // Remove "Pure Beeswax" prefix (case insensitive)
    let cleaned = productName.replace(/pure\s+beeswax\s+/gi, '');

    return cleaned.trim();
  }

async function fetchReviews(forceRefresh = false) {
  const slider = document.getElementById('reviews-slider');
  if (!slider) return;

  const cards = slider.querySelectorAll('.cart-drawer__review-card');
  if (cards.length === 0) return;

  try {
    // Use cached reviews if available (unless forcing refresh)
    if (!cachedReviews || forceRefresh) {
      const response = await fetch(`${REVIEWS_API}?action=get_reviews`);
      const data = await response.json();
      
      if (!data.reviews) {
        console.error('No reviews in response');
        return;
      }

      // Group reviews by product_handle and cache them
      cachedReviews = {};
      data.reviews.forEach(review => {
        const handle = review.product_handle;
        if (!cachedReviews[handle]) {
          cachedReviews[handle] = [];
        }
        cachedReviews[handle].push(review);
      });
    }

    // Populate review cards from cache
    populateReviewCards(cards);

  } catch (error) {
    console.error('Error fetching reviews:', error);
    showFallbackReviews(cards);
  }
}
async function prefetchReviews() {
  if (cachedReviews) return;
  try {
    console.log('🔍 Fetching reviews from API...');
    const response = await fetch(`${REVIEWS_API}?action=get_reviews`);
    const data = await response.json();
    console.log('📦 API Response:', data);

    if (!data.reviews) {
      console.warn('⚠️ No reviews found in API response');
      return;
    }

    cachedReviews = {};
    data.reviews.forEach(review => {
      const handle = review.product_handle;
      if (!cachedReviews[handle]) cachedReviews[handle] = [];
      cachedReviews[handle].push(review);
    });
    console.log('✅ Reviews cached:', cachedReviews);
  } catch (error) {
    console.error('❌ Reviews prefetch failed:', error);
  }
}

function populateReviewCards(cards) {
  let hasAnyReviews = false;

  cards.forEach(card => {
    // Skip the loading skeleton — handled separately below
    if (card.hasAttribute('data-review-skeleton')) return;

    const handle = card.dataset.handle;

    if (cachedReviews && cachedReviews[handle] && cachedReviews[handle].length > 0) {
      // Filter for only 5-star reviews
      const fiveStarReviews = cachedReviews[handle].filter(r => r.rating === 5);

      if (fiveStarReviews.length > 0) {
        // Pick a random 5-star review
        const review = fiveStarReviews[Math.floor(Math.random() * fiveStarReviews.length)];

        const textEl = card.querySelector('.review-card__text');
        const authorEl = card.querySelector('.review-card__author');
        const ratingEl = card.querySelector('.review-card__rating');

        if (textEl) textEl.textContent = `"${review.text || review.review || review.body || ''}"`;
        if (authorEl) {
          let authorName = 'Customer';
          if (review.name) {
            const parts = review.name.trim().split(' ');
            if (parts.length === 1) {
              authorName = parts[0];
            } else if (parts.length > 1) {
              const firstName = parts[0];
              const lastInitial = parts[parts.length - 1].charAt(0).toUpperCase();
              authorName = firstName + ' ' + lastInitial + '.';
            }
          }
          authorEl.textContent = `– ${authorName}`;
        }
        if (ratingEl) ratingEl.innerHTML = getStars(review.rating);

        card.style.display = ''; // Show card
        hasAnyReviews = true;
      } else {
        card.style.display = 'none'; // Hide card - no 5-star reviews
      }
    } else {
      card.style.display = 'none'; // Hide card - no matching review
    }
  });

  // Reviews have loaded, so the skeleton is done either way.
  const skeleton = document.querySelector('.cart-drawer__review-card[data-review-skeleton]');
  if (skeleton) skeleton.style.display = 'none';

  // Only show the section when a product IN THE CART actually has a review.
  // Previously it stayed visible and fell back to a fixed Wine Down quote,
  // which read as a review of whatever the shopper had just added.
  // Target the has-items section explicitly: '.cart-drawer__reviews' also
  // matches the empty-cart slider, so this used to hide THAT one instead.
  const reviewsSection = document.querySelector('.cart-drawer__reviews:not(.cart-drawer__reviews--empty)');
  if (reviewsSection) {
    reviewsSection.style.display = hasAnyReviews ? '' : 'none';
  }
}

function showFallbackReviews(cards) {
  // Hide the entire section on error
  const reviewsSection = document.querySelector('.cart-drawer__reviews');
  if (reviewsSection) {
    reviewsSection.style.display = 'none';
  }
}

function getStars(rating) {
  let stars = '';
  for (let i = 0; i < 5; i++) {
    stars += i < rating ? '★' : '☆';
  }
  return stars;
}
  // =============================================
  // SHIPPING CALCULATOR
  // =============================================
  // USPS 3-digit ZIP prefix -> state. Shopify's shipping-rates API REJECTS US
  // addresses without a province ({"province":["Select a state"]}), and the old
  // code only sent zip+country — so the API failed on every request and every
  // shopper saw the hardcoded fallback (verified live 2026-08-17). Deriving the
  // state from the ZIP keeps the single-input UX while making real rates work.
  const ZIP_STATE_EXCEPTIONS = { 201: 'VA', 733: 'TX' };
  const ZIP_STATE_RANGES = [
    [5, 5, 'NY'], [6, 9, 'PR'], [10, 27, 'MA'], [28, 29, 'RI'], [30, 38, 'NH'],
    [39, 49, 'ME'], [50, 59, 'VT'], [60, 69, 'CT'], [70, 89, 'NJ'],
    [100, 149, 'NY'], [150, 196, 'PA'], [197, 199, 'DE'], [200, 205, 'DC'],
    [206, 219, 'MD'], [220, 246, 'VA'], [247, 268, 'WV'], [270, 289, 'NC'],
    [290, 299, 'SC'], [300, 319, 'GA'], [320, 349, 'FL'], [350, 369, 'AL'],
    [370, 385, 'TN'], [386, 397, 'MS'], [398, 399, 'GA'], [400, 427, 'KY'],
    [430, 459, 'OH'], [460, 479, 'IN'], [480, 499, 'MI'], [500, 528, 'IA'],
    [530, 549, 'WI'], [550, 567, 'MN'], [570, 577, 'SD'], [580, 588, 'ND'],
    [590, 599, 'MT'], [600, 629, 'IL'], [630, 658, 'MO'], [660, 679, 'KS'],
    [680, 693, 'NE'], [700, 714, 'LA'], [716, 729, 'AR'], [730, 749, 'OK'],
    [750, 799, 'TX'], [800, 816, 'CO'], [820, 831, 'WY'], [832, 838, 'ID'],
    [840, 847, 'UT'], [850, 865, 'AZ'], [870, 884, 'NM'], [885, 885, 'TX'],
    [889, 898, 'NV'], [900, 961, 'CA'], [967, 968, 'HI'], [970, 979, 'OR'],
    [980, 994, 'WA'], [995, 999, 'AK']
  ];

  function stateFromZip(zip5) {
    const prefix = parseInt(zip5.slice(0, 3), 10);
    if (ZIP_STATE_EXCEPTIONS[prefix]) return ZIP_STATE_EXCEPTIONS[prefix];
    for (const [start, end, state] of ZIP_STATE_RANGES) {
      if (prefix >= start && prefix <= end) return state;
    }
    return null;
  }

  // ---- NYC same-day coverage -------------------------------------------
  // Shopify's shipping ZONES can't go finer than a state, so the manual
  // "Manhattan Same Day" / "NYC Same Day" rates are offered to the whole US —
  // verified 2026-08-18, a St. Petersburg FL zip (33712) was quoted both.
  // This filters them out of the DRAWER; it does not protect checkout. The
  // real fix is admin-side (Local delivery with a zip list, or a NY-only
  // zone) — see the shipping notes handed to the store owner.
  // TODO(owner): confirm the exact delivered zip prefixes before relying on
  // this list; below is the standard USPS split, not a confirmed service area.
  var NYC_ZIP3 = {
    manhattan: ['100', '101', '102'],
    // Manhattan + Staten Island(103) + Bronx(104) + Queens(110,111,113,114,116)
    // + Brooklyn(112)
    boroughs: ['100', '101', '102', '103', '104', '110', '111', '112', '113', '114', '116']
  };

  function sameDayAllowedForZip(rateName, zip5) {
    var name = (rateName || '').toLowerCase();
    if (name.indexOf('same day') === -1) return true; // not a same-day rate
    if (!zip5 || !/^\d{5}$/.test(zip5)) return false; // unknown zip: don't offer it
    var zip3 = zip5.slice(0, 3);
    var allowed = name.indexOf('manhattan') > -1 ? NYC_ZIP3.manhattan : NYC_ZIP3.boroughs;
    return allowed.indexOf(zip3) > -1;
  }

  // ---- Calculator UI states ---------------------------------------------
  // Rates take ~3.4s to come back. Without this the results area just sat
  // there unchanged and the drawer read as broken (session s_8u47wdgemmszcmc51:
  // tapped CALCULATE, stared at nothing for 4s, bounced to checkout).
  function showShippingLoading() {
    var resultsDiv = document.querySelector('.js-shipping-results');
    var defaultDiv = document.querySelector('.js-shipping-default');
    if (!resultsDiv) return;
    if (defaultDiv) defaultDiv.style.display = 'none';
    resultsDiv.innerHTML =
      '<div class="shipping-calc__loading">' +
        '<span class="shipping-calc__spinner" aria-hidden="true"></span>' +
        '<span>Fetching rates…</span>' +
      '</div>';
    resultsDiv.style.display = 'block';
    resultsDiv.setAttribute('aria-busy', 'true');
  }

  function fallbackThreshold() {
    // Free-shipping threshold in dollars, from the section setting via the
    // data attribute (single source of truth with the progress bar). 60 only
    // if the attribute is somehow missing.
    const defaultDiv = document.querySelector('.js-shipping-default');
    const t = defaultDiv && parseFloat(defaultDiv.dataset.freeThreshold);
    return t > 0 ? t : 60;
  }

  function initShippingCalculator() {
    const calcBtn = document.querySelector('.js-calc-shipping');
    const zipInput = document.querySelector('.js-shipping-zip');
    const resultsDiv = document.querySelector('.js-shipping-results');

    if (!calcBtn || !zipInput || !resultsDiv) return;

    // Re-bind guard: the observer in init() calls this again after every
    // drawer redraw; a button that already carries its listeners (survived a
    // partial redraw) must not be double-bound. The flag lives on the button
    // itself, so a REPLACED button arrives unflagged and gets wired fresh.
    if (calcBtn.dataset.calcBound) return;
    calcBtn.dataset.calcBound = '1';

    calcBtn.addEventListener('click', async () => {
      const zip = zipInput.value.trim();

      if (!zip) {
        showShippingError('Please enter a ZIP or postal code');
        return;
      }

      calcBtn.disabled = true;
      calcBtn.textContent = 'Loading...';
      showShippingLoading();

      // Measured round trip is ~3.4s, so the old 5 x 700ms poll (3.5s ceiling)
      // was finishing right on the edge and dropping real carrier rates for the
      // hardcoded fallback. Give it a genuine budget instead.
      const POLL_TIMEOUT_MS = 12000;
      const startedAt = Date.now();

      let cartTotal = 0;
      try {
        // Fetch current cart
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        cartTotal = cart.total_price / 100; // Convert from cents to dollars

        // Real rates need a 5-digit US ZIP we can map to a state; anything
        // else (foreign postal codes, unknown prefixes) uses the fallback.
        const zip5 = (zip.match(/^\d{5}/) || [])[0];
        const state = zip5 ? stateFromZip(zip5) : null;

        if (state) {
          const qs = 'shipping_address[zip]=' + encodeURIComponent(zip5) +
            '&shipping_address[country]=US' +
            '&shipping_address[province]=' + encodeURIComponent(state);

          await fetch('/cart/prepare_shipping_rates.json?' + qs, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
          });

          // Rates come back as null while Shopify is still calculating.
          while (Date.now() - startedAt < POLL_TIMEOUT_MS) {
            await new Promise(resolve => setTimeout(resolve, 700));
            const ratesResponse = await fetch('/cart/shipping_rates.json?' + qs);
            const ratesData = await ratesResponse.json();
            if (ratesData.shipping_rates && ratesData.shipping_rates.length > 0) {
              displayShippingRates(ratesData.shipping_rates, cartTotal, zip5, Date.now() - startedAt);
              return;
            }
            // Error payloads (e.g. validation) have no shipping_rates key at
            // all — no point polling those.
            if (!('shipping_rates' in ratesData)) break;
          }

          // Asked Shopify and got nothing usable (or ran out of time): say so
          // rather than quietly presenting a made-up number as a real quote.
          showShippingError("Couldn't get rates — try again, or continue to checkout where shipping is confirmed.");
          return;
        }

        // No mappable US state (foreign/unknown postal code) — we never asked
        // Shopify, so show the policy-based estimate rather than an error.
        const threshold = fallbackThreshold();
        displayShippingRates([{
          name: 'Standard Shipping',
          price: cartTotal >= threshold ? '0.00' : '10.00',
          delivery_range: [5, 7]
        }], cartTotal, zip, Date.now() - startedAt);

      } catch (error) {
        console.error('Shipping calculation error:', error);
        showShippingError("Couldn't get rates — try again, or continue to checkout where shipping is confirmed.");
      } finally {
        calcBtn.disabled = false;
        calcBtn.textContent = 'Calculate';
      }
    });

    // Allow Enter key to trigger calculation
    zipInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        calcBtn.click();
      }
    });
  }

  function displayShippingRates(rates, cartTotal, zipCode, elapsedMs) {
    const resultsDiv = document.querySelector('.js-shipping-results');
    const defaultDiv = document.querySelector('.js-shipping-default');
    if (!resultsDiv) return;

    // Drop NYC same-day options for addresses outside the delivery area —
    // Shopify offers them nationwide because zones are state-level.
    const zip5 = (String(zipCode || '').match(/^\d{5}/) || [])[0];
    const filteredOut = rates.filter(r => !sameDayAllowedForZip(r.name, zip5)).length;
    rates = rates.filter(r => sameDayAllowedForZip(r.name, zip5));
    if (!rates.length) {
      showShippingError("No rates available for that ZIP — continue to checkout where shipping is confirmed.");
      return;
    }

    // Hide default, show results
    if (defaultDiv) defaultDiv.style.display = 'none';
    resultsDiv.removeAttribute('aria-busy');

    // Latency + result telemetry, so this stays measurable in BigQuery.
    try {
      if (typeof MburTracker !== 'undefined' && MburTracker.trackCustomEvent) {
        MburTracker.trackCustomEvent('shipping_rates_shown', {
          elapsed_ms: typeof elapsedMs === 'number' ? elapsedMs : null,
          rate_count: rates.length,
          same_day_filtered: filteredOut,
          zip_prefix: zip5 ? zip5.slice(0, 3) : null
        });
      }
    } catch (e) {}

    let html = '';

    // Subtotal line
    html += `
      <div class="shipping-calc__option">
        <div class="shipping-calc__option-name">Subtotal</div>
        <div class="shipping-calc__option-details">
          <div class="shipping-calc__option-price">$${cartTotal.toFixed(2)}</div>
        </div>
      </div>
    `;

    // Display shipping options. Real API responses come sorted cheapest-first
    // and can carry 9+ carrier options — cap what the drawer lists so it stays
    // scannable (cheapest ground -> reasonable express).
    rates.slice(0, 4).forEach(rate => {
      const price = rate.price === '0.00' || rate.price === 0 ? 'FREE' : '$' + rate.price;

      // Real rates: delivery_days is [min,max] day counts; delivery_range is
      // DATE STRINGS ("2026-08-20") — only the fallback uses numeric ranges.
      // Carriers sometimes report 0 days (seen live from UPS) — that's not a
      // promise a shopper can use, so omit the line rather than print
      // "0 business days".
      let deliveryText = '5-7 business days';
      const days = rate.delivery_days && rate.delivery_days.length ? rate.delivery_days : null;
      if (days) {
        const min = days[0];
        const max = days[days.length - 1];
        if (max <= 0) {
          deliveryText = '';
        } else if (min <= 0) {
          deliveryText = `Up to ${max} business day${max === 1 ? '' : 's'}`;
        } else if (min === max) {
          deliveryText = `${min} business day${min === 1 ? '' : 's'}`;
        } else {
          deliveryText = `${min}-${max} business days`;
        }
      } else if (rate.delivery_range && typeof rate.delivery_range[0] === 'number') {
        deliveryText = `${rate.delivery_range[0]}-${rate.delivery_range[1]} business days`;
      } else if (rate.delivery_range === null && !rate.delivery_date) {
        deliveryText = ''; // e.g. same-day couriers with no estimate — omit
      }

      html += `
        <div class="shipping-calc__option">
          <div class="shipping-calc__option-name">${rate.name}</div>
          <div class="shipping-calc__option-details">
            <div class="shipping-calc__option-price">${price}</div>
            ${deliveryText ? `<div class="shipping-calc__option-time">${deliveryText}</div>` : ''}
          </div>
        </div>
      `;
    });

    // Estimate tax based on ZIP code state
    const shippingCost = rates[0].price === '0.00' || rates[0].price === 0 ? 0 : parseFloat(rates[0].price);
    const taxRate = getTaxRateByZip(zipCode);
    const estimatedTax = (cartTotal * taxRate).toFixed(2);
    const estimatedCheckout = (parseFloat(cartTotal) + shippingCost + parseFloat(estimatedTax)).toFixed(2);

    html += `
      <div class="shipping-calc__option">
        <div class="shipping-calc__option-name">Estimated Tax</div>
        <div class="shipping-calc__option-details">
          <div class="shipping-calc__option-price">~$${estimatedTax}</div>
        </div>
      </div>
      <div class="shipping-calc__tax-estimate">
        <div class="shipping-calc__tax-label">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
            <path d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
          </svg>
          Estimated Total
        </div>
        <div class="shipping-calc__tax-amount">~$${estimatedCheckout}</div>
      </div>
      <div class="shipping-calc__note">Estimates based on ZIP code • Final total at checkout</div>
    `;

    resultsDiv.innerHTML = html;
    resultsDiv.style.display = 'block';
  }

  // State-level sales tax estimate by ZIP code prefix
  function getTaxRateByZip(zip) {
    var z = parseInt(zip.toString().substring(0, 3));
    // No sales tax states
    if (z >= 995 && z <= 999) return 0;       // AK
    if (z >= 970 && z <= 979) return 0;        // OR
    if (z >= 59 && z <= 59) return 0;          // MT (590-599)
    if (z >= 590 && z <= 599) return 0;        // MT
    if (z >= 830 && z <= 831) return 0;        // NH mapped wrong — skip
    if (z >= 30 && z <= 31) return 0;          // NH (030-038)
    if (z >= 0 && z <= 0) return 0;            // placeholder

    // State tax rates by ZIP prefix ranges (approximate)
    // Northeast
    if (z >= 10 && z <= 14) return 0.08;       // NY
    if (z >= 0 && z <= 9) return 0.0625;       // CT/MA area
    if (z >= 15 && z <= 19) return 0.06;       // PA
    if (z >= 30 && z <= 38) return 0;          // NH
    if (z >= 39 && z <= 49) return 0.0625;     // ME/VT/MA
    if (z >= 50 && z <= 58) return 0.065;      // NJ
    if (z >= 70 && z <= 89) return 0.0625;     // NJ/CT

    // Southeast
    if (z >= 100 && z <= 149) return 0.08;     // NY
    if (z >= 150 && z <= 196) return 0.06;     // PA
    if (z >= 197 && z <= 199) return 0;        // DE
    if (z >= 200 && z <= 205) return 0.06;     // DC/VA
    if (z >= 206 && z <= 219) return 0.06;     // MD
    if (z >= 220 && z <= 246) return 0.053;    // VA
    if (z >= 247 && z <= 268) return 0.06;     // WV
    if (z >= 270 && z <= 289) return 0.0475;   // NC
    if (z >= 290 && z <= 299) return 0.06;     // SC
    if (z >= 300 && z <= 319) return 0.04;     // GA
    if (z >= 320 && z <= 349) return 0.06;     // FL
    if (z >= 350 && z <= 369) return 0.04;     // AL
    if (z >= 370 && z <= 385) return 0.07;     // TN
    if (z >= 386 && z <= 397) return 0.07;     // MS

    // Midwest
    if (z >= 400 && z <= 427) return 0.06;     // KY
    if (z >= 430 && z <= 459) return 0.0575;   // OH
    if (z >= 460 && z <= 479) return 0.07;     // IN
    if (z >= 480 && z <= 499) return 0.06;     // MI
    if (z >= 500 && z <= 528) return 0.06;     // IA
    if (z >= 530 && z <= 549) return 0.05;     // WI
    if (z >= 550 && z <= 567) return 0.06875;  // MN
    if (z >= 570 && z <= 577) return 0.045;    // SD
    if (z >= 580 && z <= 588) return 0.05;     // ND
    if (z >= 600 && z <= 629) return 0.0625;   // IL
    if (z >= 630 && z <= 658) return 0.04225;  // MO
    if (z >= 660 && z <= 679) return 0.065;    // KS
    if (z >= 680 && z <= 693) return 0.055;    // NE

    // South
    if (z >= 700 && z <= 714) return 0.0445;   // LA
    if (z >= 716 && z <= 729) return 0.065;    // AR
    if (z >= 730 && z <= 749) return 0.045;    // OK
    if (z >= 750 && z <= 799) return 0.0625;   // TX
    if (z >= 800 && z <= 816) return 0.029;    // CO
    if (z >= 820 && z <= 831) return 0.04;     // WY
    if (z >= 832 && z <= 838) return 0.06;     // ID
    if (z >= 840 && z <= 847) return 0.0485;   // UT
    if (z >= 850 && z <= 865) return 0.056;    // AZ
    if (z >= 870 && z <= 884) return 0.05125;  // NM
    if (z >= 889 && z <= 898) return 0.0685;   // NV

    // West
    if (z >= 900 && z <= 961) return 0.0725;   // CA
    if (z >= 962 && z <= 966) return 0;         // APO
    if (z >= 967 && z <= 968) return 0.04;      // HI
    if (z >= 980 && z <= 994) return 0.065;     // WA

    // Default fallback
    return 0.10;
  }

  function showShippingError(message) {
    const resultsDiv = document.querySelector('.js-shipping-results');
    const defaultDiv = document.querySelector('.js-shipping-default');
    if (!resultsDiv) return;

    if (defaultDiv) defaultDiv.style.display = 'none';

    resultsDiv.innerHTML = `<div class="shipping-calc__error">${message}</div>`;
    resultsDiv.style.display = 'block';
  }

  // =============================================
  // INITIALIZE
  // =============================================
  function init() {
  initEventDelegation();
  initSampleSelector();
  initApplePay();
  // prefetchReviews() removed from page load: it fired an Apps Script request on
  // EVERY page view (blog included) for content only visible inside the drawer.
  // openCart() and refreshCart() already await prefetchReviews() on demand.
  initCartNotes();
  initShippingCalculator();

  // TWO scripts redraw this drawer: this file's refreshCart() re-inits its
  // features afterwards, but global.js's CartDrawer class (the Add to Cart
  // path) redraws and re-inits NOTHING — leaving the Calculate button, the
  // free-sample picker and the order-note field present but deaf (observed
  // live: ~30 shoppers typed a ZIP since Oct 1, only ~6 ever saw rates; notes
  // typed after an add were never saved). Watch for a redraw that introduced
  // an unbound Calculate button (all three features live in the same
  // non-empty-cart markup, so it is the sentinel for the lot) and wire them
  // all again. Idempotent: calcBound gates the calculator, dataset.initialized
  // gates the sample dropdowns, and a redraw replaces the other nodes anyway.
  const drawerEl = document.querySelector('.js-cart-drawer');
  if (drawerEl && 'MutationObserver' in window) {
    new MutationObserver(function () {
      const btn = document.querySelector('.js-calc-shipping');
      if (btn && !btn.dataset.calcBound) {
        initSampleSelector();
        initApplePay();
        initCartNotes();
        initShippingCalculator();
      }
    }).observe(drawerEl, { childList: true, subtree: true });
  }
}

  window.cart = {
    open: openCart,
    close: closeCart,
    refresh: () => {
      refreshCart();
    }
  };

  // =============================================
  // HEADER CART ICON TRIGGERS
  // =============================================
  function initCartIconTriggers() {
    const cartTriggerSelectors = [
      '.js-cart-btn', '.header__icon--cart',
      '.cart-icon', '.cart-icon-bubble',
      '[data-cart-trigger]', '[data-cart-open]', '.js-cart-trigger',
      '.js-open-cart', '.header-cart', '.header__cart',
      'button[aria-label*="cart" i]',
      '.icon-cart', '.cart-link', '.CartToggle'
    ];

    cartTriggerSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        if (el.closest('.cart-drawer')) return;
        if (el.closest('.site-header__cart-btn')) return;
        if (el.dataset.cartTriggerInit) return;
        el.dataset.cartTriggerInit = 'true';

        el.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          openCart();
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      initCartIconTriggers();
    });
  } else {
    init();
    initCartIconTriggers();
  }
})();
